import { DocumentDisplayInfo, TipDropdownMenuOptions } from '../../sharedComponents/DropdownWithTips';
import { ApiStatus, DropDownOptions } from '../../types';

export interface LiabilityDisplay {
    [index: string]: string;
}

export interface LiabilityTypes {
    LiabilityTypeId: string;
    LiabilityName: string;
    AEMKey: string;
}
export interface QALiabilityCard {
    LiabilityDisplayInfo: LiabilityDisplay;
    LiabilityTypes: LiabilityTypes[];
}

export interface Category {
    categoryName: string;
    displayName: string;
    data: QALiabilityCard[];
}

export const QALiabilityContentDefaultAEM = {
    heading: 'We need a little more info',
    description:
        '<br>The details we have for you may not match or be up to date.<br><br>We may have sourced these from a credit reporting body, or our own records.<br><br>To make sure we have the most up to date details, we’ll need you to tell us a bit more.<br>',
    confirmButton: 'Confirm',
    labelAccountNumber: 'Account number',
    labelLimit: 'Credit limit',
    labelRepayments: 'Repayment amount',
    labelNumberAccountHolders: 'Account holders:',
    liabilitiesTitle: 'Liabilities that need more information',
    liabilityInstitutionTypeLabel: 'Liability institution & type',
    tellUsAboutThisLiabilityLabel: 'Tell us about this',
    chooseOptionLabel: 'Choose option',
    validations: {
        required: 'You need to choose an option',
    },
    verificationActionsDescription: {
        U: 'I\'ve already declared this',
        A: 'It\'s mine, but I didn\'t declare it',
        B: 'It\'s mine, but it\'s incorrect',
        D: 'It\'s a closed account',
        E: 'It\'s an expense',
        O: 'Someone else\'s debt or liability',
        P: 'I don\'t recognise this',
    },
    tips: {
        dontRecogniseThisDebt: 'Don\'t recognise',
    },
};

export type QALiabilityAEM = typeof QALiabilityContentDefaultAEM;

export type QALiabilityDefaultAEMTips =
    keyof typeof QALiabilityContentDefaultAEM.tips;

export interface QALiabilityApiEndpoints {
    getQALiabilityUrl: string;
    submitQALiabilityUrl?: string;
}

export interface QALiabilityCardData {
    subCategory: string;
    subCategoryId: string;
    id: number;
    liabilityDisplayInfo: DocumentDisplayInfo[];
    liabilityTypes: TipDropdownMenuOptions[];
    selectedVerificationAction?: string;
}

export interface QALiabilityCategoryData {
    categoryName: string;
    displayName: string;
    data: QALiabilityCardData[];
}

export interface QALiabilityUserAction {
    categoryName: string;
    subCategoryId: string;
    id: number;
    selectedVerificationAction: string;
}

export interface QALiabilityFormDetail {
    updatedQaLiabilityActions: QALiabilityUserAction[];
}

export interface QALiabilityData {
    categoriesRequired: QALiabilityCategoryData[];    
}

export interface QALiabilityDataPayload extends QALiabilityData {
    liabilitiesVerificationContent: string;
}

export interface QALiabilityDropDownOptions extends DropDownOptions<string> {
    description?: string;
}

export interface QALiabilityState {
    content: QALiabilityAEM;
    qaLiabilityApiStatus: ApiStatus;
    qaLiabilitySubmitStatus: ApiStatus;
    qaLiabilityData: QALiabilityData;
    validationCheck: boolean;
    noUserActionIdList: number[];
    apiEndpoints: QALiabilityApiEndpoints;
}

